<template>
	<transition name="modal">
		<div id="ecommerce_category_edit" class="modal-mask" @click="$emit('close')">
			<div class="modal-wrapper" role="document" style="overflow-y:auto;position:absolute">
				<div class="modal-container modal-dialog">
					<div class="modal-content" @click.stop>
						<div class="modal-header">
							<div class="row">
								<div class="col-xs-6">
									Edit Categories
								</div>
								<div class="col-xs-6">
									<button type="button" class="close" @click="$emit('close')" data-dismiss="modal" aria-label="Close">
										<vue-simple-svg
										:filepath="'/static/img/assets/_global/Close.svg'"
										width="50px"
										height="auto"
										class="icon"
										/>
									</button>

								</div>

							</div>
							
						</div>
						<div class="modal-body">
							
							<div id="ecommerce_category">
								<div class="row">
									<div class="col col-sm-12 col-md-12">
										<div class="form-inline" style="padding-bottom:15px;">
											<input type="text" class="form-control mb-2 mr-sm-2 mb-sm-0" id="categoryInput" placeholder="Category Name" v-model="newCategory.name">

											<button type="submit" class="btn btn-primary transparent" @click="onAddCategory"><i class="fa fa-plus middle"></i> Add Category</button>
										</div>
										<ul class="list-category-group pb-3">
											<draggable :list="categorylist" class="dragArea" :move="checkMove">
											<li class="list-category" v-for="(category,index) in categorylist" :key="'category_'+ index">
												<div class="row">
													<div class="col col-sm-10 grab" @click="onSelectCategory(index)" ><span class="glyphicon glyphicon-sort" style="margin-right: 10px"></span> {{ category.name }}</div>
													<div class="col col-sm-2 text-right">
														<a href="javascript:void(0);" @click="onEditCategory(index)" style="margin-right: 10px"><i class="fa fa-pencil-alt" data-toggle="modal" data-target="#modal_edit_category" aria-hidden="true" ></i></a>
														<a href="javascript:void(0);" @click="onDeleteCategory(index, category.id)"><i class="fa fa-remove" aria-hidden="true" ></i></a>
													</div>
												</div>
											</li>
											</draggable>
										</ul>
									</div>

								</div>

								<ecommerce-category-edit :category="currentCategory" v-if="showEdit" @close="close()"></ecommerce-category-edit>
								
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import ecommerceCategoryEdit from './ecommerce-category-edit'
// import ecommerceSubCategoryEdit from './ecommerce-sub-category-edit'
import api from '@/api'
import draggable from 'vuedraggable'

export default{
  props: ['value'],
  computed: {
  pageid: function () {
  return this.$store.state.selectedBot.pageid
}
},
  data: function () {
  return {
  categorylist: this.value,
  currentCategory: null,
  currentSubCategory: null,
  newCategory: {
  name: null
},
  newSubCategory: {
  name: null
},
  showEdit: false
}
},
  mounted: function () {
  let vm = this
  document.addEventListener('keydown', (e) => {
  if (e.keyCode == 27) {
  vm.$emit('close')
}
})
	},
  components: {
  'ecommerce-category-edit': ecommerceCategoryEdit,
  draggable
		// 'ecommerce-sub-category-edit' : ecommerceSubCategoryEdit
},
  methods: {
  close: function () {
  let vm = this
  vm.showEdit = false
  vm.nextTick(function () {
				// vm.$emit('input',vm.product)
})
},
  checkMove: function (event) {
  let vm = this
  vm.$emit('input', vm.categorylist)
        },
  onEditCategory: function (index) {
  this.currentCategory = this.categorylist[index]
  this.showEdit = true
},
  onSelectCategory: function (index) {
  this.currentCategory = this.categorylist[index]
},
  onAddCategory: function () {
  let vm = this
  let data = {
  pageid: vm.pageid,
  name: vm.newCategory.name
}
  api.saveCategory(data, function (error, response) {
  if (error) {
  console.error(error)
  return
}

  vm.newCategory.id = response.categoryid
  vm.newCategory.subcategories = []

  vm.categorylist.push(vm.newCategory)
  vm.newCategory = { name: null }

  vm.$emit('input', vm.categorylist)
  vm.$emit('onCategoryChange')
})
},
  onDeleteCategory: function (index, id) {
  if (confirm('Do you want to delete this?')) {
  let vm = this
  api.deleteCategory(id, function (error, response) {
  if (error) {
  console.error(error)
  return
}

  vm.categorylist.splice(index, 1)
  vm.$emit('input', vm.categorylist)
  vm.$emit('onCategoryChange')
})
}
},
  onAddSubCategory: function () {
  let vm = this
  let data = {
  pageid: vm.pageid,
  name: vm.newSubCategory.name,
  categoryid: vm.currentCategory.id
}
  api.saveSubCategory(data, function (error, response) {
  if (error) {
  console.error(error)
  return
}

  vm.newSubCategory.id = response.subcategoryid

  let categoryIndex = vm.categorylist.findIndex(category => { return category.id == vm.currentCategory.id })
  vm.categorylist[categoryIndex].subcategories.push(vm.newSubCategory)
  vm.newSubCategory = { name: null }
})
},
  onEditSubCategory: function (index) {
  this.currentSubCategory = this.currentCategory.subcategories[index]
},
  onDeleteSubCategory: function (index, id) {
  if (confirm('Do you want to delete this?')) {
  let vm = this
  api.deleteSubCategory(id, function (error, response) {
  if (error) {
  console.error(error)
  return
}

  vm.currentCategory.subcategories.splice(index, 1)
})
}
}
},
  watch: {
  value: function (newVal, oldVal) {
  this.categorylist = newVal
}
}
}
</script>

<style>
	.list-category-group{
	    text-decoration: none;
	    list-style-type: none;
	    padding-left: 0px
	}

	.list-category:first-child{
		border-top: 1px solid #eee;
	}

	.list-category{
		padding: 10px;

		border-bottom: 1px solid #eee;
		border-left: 1px solid #eee;
		border-right: 1px solid #eee;
	}

	.list-category.active{
		background-color:#007bff;
		color: white;
	}

	.grab{
		cursor: -webkit-grab; cursor: grab;
	}
</style>


// WEBPACK FOOTER //
// src/components/view/template/event/Categories.vue